import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useStore } from "@/store";
import { useIsLaptopOrBigger } from "@/styles/useStyles";
import {
  useIsPartnerApp,
  useIsStudentApp,
} from "@/store/selectors/featureSelectors";
import {
  useAdvizers,
  useIndustryFilterOptions,
  useJobFunctionFilterOptions,
  useSubjectFilterOptions,
  useToggleAdvizerSearchFilterOption,
  useTraitFilterOptions,
} from "@/store/selectors";

export const UiUpdates = () => {
  const { pathname } = useLocation();
  const { advizers } = useAdvizers();
  const [searchParams, setSearchParams] = useSearchParams();
  const isLandingPath = pathname === "/";
  const isExplorePath = pathname === "/explore";
  const isStudentApp = useIsStudentApp();
  const isLaptopOrBigger = useIsLaptopOrBigger();
  const isPartnerApp = useIsPartnerApp();
  const { subjects } = useSubjectFilterOptions();
  const { jobFunctions } = useJobFunctionFilterOptions();
  const { industries } = useIndustryFilterOptions();
  const { traits } = useTraitFilterOptions();
  const traitSearchParam = searchParams.get("trait");
  const industrySearchParam = searchParams.get("industry");
  const jobFunctionSearchParam = searchParams.get("jobFunction");
  const subjectSearchParam = searchParams.get("subject");

  const toggleFilterOption = useToggleAdvizerSearchFilterOption();
  const setActiveFilterPartnerId = useStore(
    (state) => state.advizerSearch.setActiveFilterPartnerId,
  );
  const setIsInlineAdvizerSearchOpen = useStore(
    (state) => state.advizerSearch.setIsInlineAdvizerSearchOpen,
  );

  const setCollapseHeader = useStore(
    (state) => state.advizerSearch.setCollapseHeader,
  );

  useEffect(() => {
    setCollapseHeader(false);
  }, [pathname, setCollapseHeader]);

  useEffect(() => {
    if (searchParams.get("alumFilterPartnerId")) {
      setActiveFilterPartnerId(searchParams.get("alumFilterPartnerId") || null);
      setSearchParams({});
    }
  }, [searchParams, setActiveFilterPartnerId, setSearchParams]);

  useEffect(() => {
    if (isExplorePath && isLaptopOrBigger && !isPartnerApp) {
      setIsInlineAdvizerSearchOpen(true);
    }
  }, [
    isExplorePath,
    isLandingPath,
    isLaptopOrBigger,
    setIsInlineAdvizerSearchOpen,
    isStudentApp,
    isPartnerApp,
  ]);

  useEffect(() => {
    if (!isExplorePath || advizers.length === 0) return;
    if (traitSearchParam && traits.length > 0) {
      const trait = traits.find((trait) => trait.slug === traitSearchParam);
      if (trait) {
        console.log("trait", trait);
        setTimeout(() => {
          toggleFilterOption("traits", trait?.id || "");
          setSearchParams({});
        }, 1000);
      }
    }

    if (industrySearchParam && industries.length > 0) {
      const industry = industries.find(
        (industry) => industry.slug === industrySearchParam,
      );
      if (industry) {
        console.log("industry", industry);
        setTimeout(() => {
          toggleFilterOption("industries", industry?.id || "");
          setSearchParams({});
        }, 1000);
      }
    }

    if (jobFunctionSearchParam && jobFunctions.length > 0) {
      const jobFunction = jobFunctions.find(
        (jobFunction) => jobFunction.slug === jobFunctionSearchParam,
      );
      if (jobFunction) {
        console.log("jobFunction", jobFunction);
        setTimeout(() => {
          toggleFilterOption("jobFunctions", jobFunction?.id || "");
          setSearchParams({});
        }, 1000);
      }
    }

    if (subjectSearchParam && subjects.length > 0) {
      const subject = subjects.find(
        (subject) => subject.slug === subjectSearchParam,
      );
      if (subject) {
        console.log("subject", subject);
        setTimeout(() => {
          toggleFilterOption("subjects", subject?.id || "");
          setSearchParams({});
        }, 1000);
      }
    }
  }, [
    subjects,
    jobFunctions,
    industries,
    traits,
    traitSearchParam,
    industrySearchParam,
    jobFunctionSearchParam,
    subjectSearchParam,
    toggleFilterOption,
    isExplorePath,
    advizers.length,
    setSearchParams,
  ]);

  return null;
};
